import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Store, Pencil, X } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function Posteggi() {
  const { text } = useSettings();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ nome: "", fornitore: "", settore: "", note: "" });
  const [editId, setEditId] = useState(null);

  const load = async () => {
    const { data } = await api.get("/posteggi");
    setItems(data);
  };
  useEffect(() => { load().catch(() => {}); }, []);

  const startEdit = (p) => { setEditId(p.id); setForm({ nome: p.nome, fornitore: p.fornitore || "", settore: p.settore || "", note: p.note || "" }); };
  const cancelEdit = () => { setEditId(null); setForm({ nome: "", fornitore: "", settore: "", note: "" }); };

  const create = async (e) => {
    e.preventDefault();
    if (!form.nome) { toast.error("Il nome del posteggio è obbligatorio"); return; }
    try {
      if (editId) { await api.put(`/posteggi/${editId}`, form); toast.success("Posteggio aggiornato"); }
      else { await api.post("/posteggi", form); toast.success("Posteggio aggiunto"); }
      cancelEdit();
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const remove = async (id) => {
    try { await api.delete(`/posteggi/${id}`); toast.success("Eliminato"); load(); }
    catch (err) { toast.error(apiError(err)); }
  };

  const input = "w-full bg-slate-800 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 outline-none focus:border-primary";

  return (
    <div className="animate-fade-up">
      <h1 className="font-display font-black text-4xl text-slate-50 tracking-tight mb-1">{text("posteggi_title")}</h1>
      <p className="text-slate-400 mb-6">{text("posteggi_subtitle")}</p>

      <form onSubmit={create} data-testid="posteggio-form" className="bg-slate-900/50 border border-slate-800 rounded-md p-5 mb-8 grid grid-cols-1 md:grid-cols-4 gap-3">
        <input data-testid="posteggio-nome" placeholder="Nome / N° posteggio" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className={input} />
        <input data-testid="posteggio-fornitore" placeholder="Fornitore" value={form.fornitore} onChange={(e) => setForm({ ...form, fornitore: e.target.value })} className={input} />
        <input placeholder="Settore / corsia" value={form.settore} onChange={(e) => setForm({ ...form, settore: e.target.value })} className={input} />
        <button data-testid="posteggio-submit" type="submit" className="bg-primary text-slate-950 font-semibold rounded-md px-4 py-2 flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
          {editId ? <Pencil className="w-4 h-4" /> : <Plus className="w-4 h-4" />} {editId ? "Aggiorna" : "Aggiungi"}
        </button>
        {editId && <button type="button" data-testid="posteggio-cancel" onClick={cancelEdit} className="md:col-span-4 text-sm text-slate-400 hover:text-slate-200 flex items-center gap-1"><X className="w-3 h-3" /> Annulla modifica</button>}
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="posteggi-list">
        {items.length === 0 && <p className="text-slate-500 text-sm">Nessun posteggio.</p>}
        {items.map((p) => (
          <div key={p.id} data-testid={`posteggio-${p.id}`} className="bg-slate-900/50 border border-slate-800 rounded-md p-4 flex items-start gap-3">
            <div className="w-10 h-10 rounded-md bg-blue-500/15 flex items-center justify-center shrink-0">
              <Store className="w-5 h-5 text-blue-400" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-100">{p.nome}</div>
              {p.fornitore && <div className="text-sm text-slate-400">{p.fornitore}</div>}
              {p.settore && <div className="text-xs text-slate-500 uppercase tracking-wider mt-1">{p.settore}</div>}
            </div>
            <button data-testid={`edit-posteggio-${p.id}`} onClick={() => startEdit(p)} className="text-slate-500 hover:text-primary">
              <Pencil className="w-4 h-4" />
            </button>
            <button data-testid={`delete-posteggio-${p.id}`} onClick={() => remove(p.id)} className="text-slate-500 hover:text-red-400">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
